import { api, baseUrl } from "../config/server";

const API_ROOT_URL = api + baseUrl;

const getHeaders = () => {
  const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
  };
  return headers;
};

const getAuthHeaders = () => {
  const userAS = localStorage.getItem("user");
  let token = "";

  if (userAS) {
    // Se esiste un utente
    const user = JSON.parse(userAS);
    token = user.authToken;
  }

  return {
    ...getHeaders(),
    Authorization: "Bearer " + token,
  };
};

const requests = {
  ///////////////////////////////////////////////////////////
  // SESSIONS

  signUp: (newUserData) => {
    return {
      url: `${API_ROOT_URL}/account/register`,
      method: "POST",
      headers: getHeaders(),
      data: newUserData,
    };
  },

  login: (credentials) => {
    return {
      url: `${API_ROOT_URL}/account/login`,
      method: "POST",
      headers: getHeaders(),
      data: credentials,
    };
  },

  ///////////////////////////////////////////////////////////
  // USER

  getUser: () => {
    return {
      url: `${API_ROOT_URL}/account`,
      method: "GET",
      headers: getAuthHeaders(),
    };
  },

  updateUser: (updates) => {
    return {
      url: `${API_ROOT_URL}/account`,
      method: "PUT",
      headers: getAuthHeaders(),
      data: updates,
    };
  },

  deleteUser: () => {
    return {
      url: `${API_ROOT_URL}/account`,
      method: "DELETE",
      headers: getAuthHeaders(),
    };
  },

  ///////////////////////////////////////////////////////////
  // STORE

  create: (newStoreData) => {
    return {
      url: `${API_ROOT_URL}/store`,
      method: "POST",
      headers: getAuthHeaders(),
      data: newStoreData,
    };
  },

  getAllStore: () => {
    return {
      url: `${API_ROOT_URL}/store`,
      method: "GET",
      headers: getAuthHeaders(),
    };
  },

  getStoreById: (storeId) => {
    return {
      url: `${API_ROOT_URL}/store/${storeId}`,
      method: "GET",
      headers: getAuthHeaders(),
    };
  },
  
  duplicate: (storeId) => {
    return {
      url: `${API_ROOT_URL}/store/${storeId}/duplicate`,
      method: "POST",
      headers: getAuthHeaders(),
    };
  },

  updateStore: (storeId, updates) => {
    return {
      url: `${API_ROOT_URL}/store/${storeId}`,
      method: "PUT",
      headers: getAuthHeaders(),
      data: updates,
    };
  },

  deleteStore: (storeId) => {
    return {
      url: `${API_ROOT_URL}/store/${storeId}`,
      method: "DELETE",
      headers: getAuthHeaders(),
    };
  },
};

export default requests;
